export default __webpack_public_path__ + "images/apple.b022a5f2.svg";